import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ClerkProvider } from '@clerk/clerk-react';

const PUBLISHABLE_KEY = 'pk_live_Y2xlcmsuc3BpcmFsY3JlYXRpb25zLmNvLnVrJA';

const signInContainer = document.createElement('div');
signInContainer.id = 'sc-signin-toast-container';
document.body.appendChild(signInContainer);

const style = document.createElement('style');
style.textContent = `
  @keyframes scToastAnim {
    0%   { opacity: 0; }
    10%  { opacity: 1; }
    80%  { opacity: 1; }
    100% { opacity: 0; }
  }
  @keyframes pulseRing {
    0%   { transform: scale(1); opacity: 0.6; }
    100% { transform: scale(3); opacity: 0; }
  }
  @keyframes circleShimmer {
    0%    { fill: rgba(156,163,175,0.25); }
    70%   { fill: rgba(156,163,175,0.25); }
    82%   { fill: rgba(74,222,128,0.85);  }
    93%   { fill: rgba(74,222,128,0.85);  }
    100%  { fill: rgba(156,163,175,0.25); }
  }
  @keyframes uptimeTextShimmer {
    0%    { fill: rgba(156,163,175,0.5); }
    70%   { fill: rgba(156,163,175,0.5); }
    82%   { fill: rgba(74,222,128,0.9);  }
    93%   { fill: rgba(74,222,128,0.9);  }
    100%  { fill: rgba(156,163,175,0.5); }
  }
  .sc-toast-active {
    animation: scToastAnim 4s ease forwards !important;
  }
`;
document.head.appendChild(style);

const toastEl = document.createElement('div');
toastEl.style.cssText = 'display:none;position:fixed;top:80px;left:50%;transform:translateX(-50%);background:rgba(71,85,105,0.95);backdrop-filter:blur(12px);padding:clamp(10px,2vw,16px) clamp(14px,3vw,24px);border-radius:16px;box-shadow:0 20px 60px rgba(0,0,0,0.3);align-items:center;gap:10px;z-index:2147483647;white-space:nowrap;pointer-events:none;';
toastEl.innerHTML = '<svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="white" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 16l-4-4m0 0l4-4m-4 4h11M10 20H6a2 2 0 01-2-2V6a2 2 0 012-2h4"/></svg><span style="color:white;font-size:clamp(13px,3vw,16px);font-weight:600;font-family:sans-serif">Signed out successfully</span>';
document.body.appendChild(toastEl);

function showToast() {
  toastEl.style.display = 'flex';
  toastEl.classList.remove('sc-toast-active');
  void toastEl.offsetWidth;
  toastEl.classList.add('sc-toast-active');
}

// If we flagged a sign-out before navigation, show the toast now
if (sessionStorage.getItem('sc-signed-out') === '1') {
  sessionStorage.removeItem('sc-signed-out');
  // Small delay to let the page fully render first
  setTimeout(showToast, 300);
}

// Called by sign-out buttons — set the flag then let Clerk navigate
window.__scSignOutToast = function() {
  sessionStorage.setItem('sc-signed-out', '1');
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
      <App />
    </ClerkProvider>
  </React.StrictMode>
);